import {platform} from '../../platform';
import {env} from './general';

export const getHostNameFromURL = url => {
  try {
    const parsedURL = new URL(url);
    return parsedURL.hostname;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error parsing URL:', error);
    return '';
  }
};

/**
 * Reads a query parameter from the current location.
 *
 * Web reads `location.search`; native reads the deep link that opened the app.
 *
 * @param {string} name - Parameter name.
 * @returns {string|null}
 */
export const getQueryParam = name => {
  const p = String(name);
  if (!p) {
    return null;
  }
  return platform().navigation.getQueryParam(p);
};

/**
 * Sends the user to an external URL.
 *
 * @param {string} url - Destination.
 * @param {boolean} newTab - Web: open in a new tab. Native: open in a browser
 *   sheet rather than handing off to the system browser.
 * @returns {void}
 */
export const redirect = (url, newTab = false) => {
  if (!url) {
    return;
  }
  platform().navigation.openUrl(url, {newTab});
};

export const redirectToBookme = (path, newTab = true) => {
  const baseUrl = env('REACT_APP_BOOKME_URL');
  if (!baseUrl) {
    return;
  }
  const cleanPath = String(path).replace(/^\/+|\/+$/g, '');
  const url = `${baseUrl}/${cleanPath}`;
  redirect(url, newTab);
};

export const redirectToAppy = (path, newTab = true) => {
  const baseUrl = env('REACT_APP_APPLY_URL');
  if (!baseUrl) {
    return;
  }
  const cleanPath = String(path).replace(/^\/+|\/+$/g, '');
  const url = `${baseUrl}/${cleanPath}`;
  redirect(url, newTab);
};
